// Tope del rango de fechas del calendario admin (/calendario, todas las
// propiedades). Round 2026-09-11: el owner pidió poder ver hasta 14 meses (el
// selector cortaba en 90 días).
//
// El backend aplica el MISMO tope en los endpoints de la grilla que tienen un
// límite propio (backend/src/utils/rangoCalendario.js — hoy, el resumen de
// Mercado por rango). Si cambias el número, cámbialo en los dos lados:
// backend/tests/utils/rangoCalendario.test.js compara las dos copias.
import dayjs from "dayjs";
import type { Dayjs } from "dayjs";

export const RANGO_CALENDARIO_MAX_MESES = 14;

export const MENSAJE_RANGO_CALENDARIO_MAXIMO = `No se puede elegir un rango de más de ${RANGO_CALENDARIO_MAX_MESES} meses. Acorta las fechas.`;

export const MENSAJE_RANGO_CALENDARIO_RECORTADO = `El calendario muestra hasta ${RANGO_CALENDARIO_MAX_MESES} meses: se ven solo los primeros ${RANGO_CALENDARIO_MAX_MESES} meses de ese rango.`;

/** Rango del calendario en `YYYY-MM-DD`, como lo guarda useCalendarioLogic. */
export interface RangoCalendarioISO {
  from: string;
  to: string;
}

/**
 * ¿El rango [desde, hasta] supera el tope? `hasta` puede llegar hasta
 * desde + 14 meses, inclusive (con el día recortado a fin de mes, como dayjs).
 */
export function excedeRangoCalendario(desde: Dayjs, hasta: Dayjs): boolean {
  return hasta.isAfter(desde.add(RANGO_CALENDARIO_MAX_MESES, "month"), "day");
}

/**
 * Recorta a 14 meses un rango que NO pasó por el selector: los deep-links de
 * /arriendos, Home y Alertas y el buscador por código arman el rango con las
 * fechas de un registro, y uno más largo que el tope abría el calendario sin
 * límite (con la fila de Mercado vacía por un 400 silencioso). Conserva `from`
 * —el inicio del registro— y corta `to`. Un rango inválido o invertido pasa tal
 * cual: eso no es un problema de tope.
 */
export function acotarRangoCalendario(rango: RangoCalendarioISO): {
  rango: RangoCalendarioISO;
  recortado: boolean;
} {
  const desde = dayjs(rango.from);
  const hasta = dayjs(rango.to);
  if (!desde.isValid() || !hasta.isValid() || !excedeRangoCalendario(desde, hasta)) {
    return { rango, recortado: false };
  }
  return {
    rango: {
      from: rango.from,
      to: desde.add(RANGO_CALENDARIO_MAX_MESES, "month").format("YYYY-MM-DD"),
    },
    recortado: true,
  };
}
